import React from "react";
import * as constants from '../../constants';
import { widgetSettingFieldsBorder } from "../../models";
import CPSettingSize from "../../../../../UI/Settings/CPSettingSize";
import CPSettingRadio from "../../../../../UI/Settings/CPSettingRadio";
import CPSettingRange from "../../../../../UI/Settings/CPSettingRange";
import CPSettingColor from "../../../../../UI/Settings/CPSettingColor";

const FieldsStyles = ({eventSettings, onChange}) => {
    return (
        <>
            <CPSettingSize
                name={constants.WIDGET_FIELDS_HEIGHT}
                label="Высота полей"
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_HEIGHT]}
                defaultValue={'42px'}
                hint="Минимальная высота поля - 36px"
                minValue={36}
                onChange={onChange}
            />
            <CPSettingRadio
                name={constants.WIDGET_FIELDS_PERIMETER_BORDER}
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_PERIMETER_BORDER]}
                defaultValue="all"
                label="Контур полей"
                options={widgetSettingFieldsBorder}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_FIELDS_BORDER_RADIUS}
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_BORDER_RADIUS]}
                label="Скругление углов у контура полей"
                defaultValue={'8px'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_FIELD_ERROR_BORDER_RADIUS}
                eventValue={eventSettings?.[constants.WIDGET_FIELD_ERROR_BORDER_RADIUS]}
                label="Скругление углов у поля с ошибкой"
                defaultValue={'8px'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_FIELDS_BORDER_WIDTH}
                label="Толщина линии контура полей"
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_BORDER_WIDTH]}
                defaultValue={'1px'}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_FIELDS_BORDER_COLOR}
                label="Цвет линии контура полей"
                eventColor={eventSettings?.[constants.WIDGET_FIELDS_BORDER_COLOR]}
                defaultColor="#3A3A3A"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_FIELDS_BORDER_BLUR}
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_BORDER_BLUR]}
                label="Размытие контура полей"
                defaultValue={'0px'}
                onChange={onChange}
            />
            <CPSettingRange
                name={constants.WIDGET_FIELDS_BORDER_OPACITY}
                value={eventSettings?.[constants.WIDGET_FIELDS_BORDER_OPACITY]}
                defaultValue={100}
                label="Прозрачность контура полей"
                step={5}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_FIELDS_BACKGROUND_COLOR}
                label="Цвет фона внутри поля"
                eventColor={eventSettings?.[constants.WIDGET_FIELDS_BACKGROUND_COLOR]}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
            <CPSettingRange
                name={constants.WIDGET_FIELDS_BACKGROUND_OPACITY}
                value={eventSettings?.[constants.WIDGET_FIELDS_BACKGROUND_OPACITY]}
                defaultValue={100}
                label="Прозрачность фона внутри поля"
                step={10}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_FIELDS_BACKGROUND_BLUR}
                eventValue={eventSettings?.[constants.WIDGET_FIELDS_BACKGROUND_BLUR]}
                label="Размытие фона внутри полей"
                defaultValue={'0px'}
                onChange={onChange}
            />
        </>
    );
};

export default FieldsStyles;
